'use client';

import { createContext, useContext } from 'react';

import type { ResponsiveBreakpoint } from '../../types/responsiveOption';

type Density = 'compact' | 'default' | 'spacious';

interface ListContextValue {
  /** Default (non-responsive) density value. */
  density: Density;
  /** Breakpoint overrides for density, if a responsive object was provided. */
  responsiveDensity: ResponsiveBreakpoint<Density> | undefined;
  /** Colour scheme. Propagated from the nearest ancestor `List`. */
  color: 'neutral' | 'static-white' | 'accent-primary';
  /** Vertical alignment of row content. Propagated from the nearest ancestor `List`. */
  alignItems: 'top' | 'center';
  /** Corner shape of items. Propagated from the nearest ancestor `List`. */
  shape: 'square' | 'rounded';
}

const ListContext = createContext<ListContextValue | null>(null);

ListContext.displayName = 'ListContext';

function useListContext(): ListContextValue | null {
  return useContext(ListContext);
}

interface ListItemButtonContextValue {
  /** Whether the button is disabled. */
  isDisabled: boolean;
  /** Whether the button is selected. */
  isSelected: boolean;
}

const ListItemButtonContext = createContext<ListItemButtonContextValue | null>(
  null
);

ListItemButtonContext.displayName = 'ListItemButtonContext';

function useListItemButtonContext(): ListItemButtonContextValue | null {
  return useContext(ListItemButtonContext);
}

export {
  ListContext,
  type ListContextValue,
  useListContext,
  ListItemButtonContext,
  type ListItemButtonContextValue,
  useListItemButtonContext,
};
